var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item.term",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-edit-dialog', {
          scopedSlots: _vm._u([{
            key: "input",
            fn: function fn() {
              return [_c('v-text-field', _vm._b({
                staticClass: "my-3",
                attrs: {
                  "label": "분류명(국문)"
                },
                on: {
                  "input": _vm.emit
                },
                model: {
                  value: item.term.ko,
                  callback: function callback($$v) {
                    _vm.$set(item.term, "ko", $$v);
                  },
                  expression: "item.term.ko"
                }
              }, 'v-text-field', _vm.attrs_input, false)), _c('v-text-field', _vm._b({
                staticClass: "my-3",
                attrs: {
                  "label": "분류명(영문)"
                },
                on: {
                  "input": _vm.emit
                },
                model: {
                  value: item.term.en,
                  callback: function callback($$v) {
                    _vm.$set(item.term, "en", $$v);
                  },
                  expression: "item.term.en"
                }
              }, 'v-text-field', _vm.attrs_input, false))];
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(item.term.ko))]), _c('div', [_vm._v(_vm._s(item.term.en))])])];
      }
    }, {
      key: "item.type",
      fn: function fn(_ref2) {
        var _vm$workClassificatio;

        var item = _ref2.item;
        return [_c('v-edit-dialog', {
          scopedSlots: _vm._u([{
            key: "input",
            fn: function fn() {
              return [_c('v-select', _vm._b({
                staticClass: "my-3",
                attrs: {
                  "label": "표기유형",
                  "items": _vm.workClassificationTypes
                },
                on: {
                  "input": _vm.emit
                },
                model: {
                  value: item.type,
                  callback: function callback($$v) {
                    _vm.$set(item, "type", $$v);
                  },
                  expression: "item.type"
                }
              }, 'v-select', _vm.attrs_input, false))];
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" " + _vm._s((_vm$workClassificatio = _vm.workClassificationTypes.find(function (_ref3) {
          var value = _ref3.value;
          return value == item.type;
        })) === null || _vm$workClassificatio === void 0 ? void 0 : _vm$workClassificatio.text) + " ")])];
      }
    }, {
      key: "item.desc",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-edit-dialog', {
          scopedSlots: _vm._u([{
            key: "input",
            fn: function fn() {
              return [item.type == _vm.LIST.value ? [_c('classification-list-combobox', _vm._b({
                on: {
                  "input": _vm.emit
                },
                model: {
                  value: item.list,
                  callback: function callback($$v) {
                    _vm.$set(item, "list", $$v);
                  },
                  expression: "item.list"
                }
              }, 'classification-list-combobox', Object.assign({}, _vm.attrs_input, {
                class: 'my-3'
              }), false))] : _vm._e(), item.type == _vm.DESC.value ? [_c('v-text-field', _vm._b({
                staticClass: "my-3",
                attrs: {
                  "label": "텍스트"
                },
                on: {
                  "input": _vm.emit
                },
                model: {
                  value: item.desc,
                  callback: function callback($$v) {
                    _vm.$set(item, "desc", $$v);
                  },
                  expression: "item.desc"
                }
              }, 'v-text-field', _vm.attrs_input, false))] : _vm._e()];
            },
            proxy: true
          }], null, true)
        }, [item.type == _vm.LIST.value ? [item.list.length > 0 ? _c('v-row', {
          staticClass: "pl-1 pb-1 mx-n1",
          staticStyle: {
            "width": "100%",
            "background": "white",
            "pointer-events": "none"
          },
          attrs: {
            "no-gutters": ""
          }
        }, _vm._l(item.list, function (_ref5) {
          var term = _ref5.term,
              isIt = _ref5.isIt;
          return _c('v-col', {
            key: term,
            staticClass: "pa-0 pt-1 pr-1",
            attrs: {
              "cols": item.list.length > 2 ? 4 : 12
            }
          }, [isIt ? [_c('v-chip', {
            staticClass: "rounded-0 d-flex justify-center",
            attrs: {
              "outlined": ""
            }
          }, [_vm._v(_vm._s(term))])] : [_c('v-chip', {
            staticClass: "rounded-0 d-flex justify-center",
            attrs: {
              "color": "grey lighten-3",
              "text-color": "grey"
            }
          }, [_vm._v(_vm._s(term))])]], 2);
        }), 1) : [_vm._v("추가된 항목이 없습니다")]] : _vm._e(), item.type == _vm.DESC.value ? [_c('div', [_vm._v(_vm._s(item.desc))])] : _vm._e()], 2)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "color": "red darken-4"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-minus")])], 1)];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider'), _c('v-row', {
          attrs: {
            "align": "center",
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "px-4 py-2",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-icon', {
          attrs: {
            "disabled": _vm.upDisabled
          },
          on: {
            "click": _vm.upItem
          }
        }, [_vm._v("mdi-chevron-up")]), _c('v-icon', {
          attrs: {
            "disabled": _vm.downDisabled
          },
          on: {
            "click": _vm.downItem
          }
        }, [_vm._v("mdi-chevron-down")])], 1), _c('v-spacer'), _c('v-col', {
          staticClass: "px-4 py-2 ml-auto",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "color": "primary darken-4"
          },
          on: {
            "click": _vm.add
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'v-data-table', _vm.attrs_table, false));
}
var staticRenderFns = []

export { render, staticRenderFns }